import React, { useState, useRef, useEffect, useCallback, useContext } from 'react'
// import { usePopupContext } from '../../shared/contexts/popupclose-context'
import { PopupCloseContext, UserInitalValue } from '../../shared/contexts/popupclose-context'
import './popup.css'
interface PopupProps {
  buttonRef?: React.RefObject<HTMLButtonElement>;
  ref?: React.RefObject<HTMLButtonElement>
  popupId?: string;
  options?: any;
  content?: any;
  onSelect?: any;
  targetRef?: any;
  onClose?: any;
  className?: any;
  popupContent?: any;
  setMultiplePopup?: (id: string | null) => void;
  popupHeaderClass?: any;
  popupTitle?: any
  popupHeaderClose?: any
  popupContentClass?: any
  popupActions?: any
  popupFooterClass?: any
  popupFooterCloseIcon?: any
  popupFooterClose?: any
  popuparrow?:any
  closebtnclass?:any
  onClick?:any
  onPositionChange?: (top: number) => void;
}

const Popups: React.FC<PopupProps> = ({ buttonRef, popupId, className, popupHeaderClass, popupTitle, popupHeaderClose, popupContent, popupContentClass,closebtnclass, popupActions, popupFooterClass, popupFooterCloseIcon, popupFooterClose, onPositionChange, popuparrow }) => {
  const { multiplePopup, setMultiplePopup }: typeof UserInitalValue = useContext(PopupCloseContext)
  const [popupPosition, setPopupPosition] = useState<{ top: number; left: number; maxHeight: any; arrowtop:any; arrowleft:any }>({ top: 0, left: 0, maxHeight: 0, arrowtop: 0,arrowleft:0 })
  const popupRef = useRef<HTMLDivElement>(null)
  const [isVisible, setIsVisible] = useState(false)
  const tabRef = useRef<HTMLHeadingElement | null>(null)
  //...Popup tab focus//
  useEffect(() => {
    const handleFocus = (e: KeyboardEvent) => {
      if (!popupRef.current) return
      const focusableElements = Array.from(
        popupRef.current.querySelectorAll<HTMLElement>(
          'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
        )
      ).filter(el => !el.hasAttribute('disabled'))
      if (focusableElements.length === 0) return
      const firstElement =  tabRef.current
      const lastElement = focusableElements[focusableElements.length - 1]
      if (e.key === 'Tab') {
        if (e.shiftKey && document.activeElement === firstElement) {
          e.preventDefault()
          lastElement.focus()
        } else if (!e.shiftKey && document.activeElement === lastElement) {
          e.preventDefault()
          firstElement?.focus()
        }
      }
    }
     tabRef.current?.focus()
    document.addEventListener('keydown', handleFocus)
    return () => {
      document.removeEventListener('keydown', handleFocus)
    }
  }, [])
  const updatePopupPosition = useCallback(() => {
    if (buttonRef?.current && popupRef.current) {
      const buttonRect = buttonRef.current.getBoundingClientRect()
      const parentDiv = buttonRef.current.offsetParent as HTMLElement
      const parentRect = parentDiv?.getBoundingClientRect()
      const popupRect = popupRef.current.getBoundingClientRect()
 
      let top = buttonRect.bottom - (parentRect?.top || 0) // Default to below the button
      let left = buttonRect.left - (parentRect?.left || 0) // Align left with button
      let maxHeight = 0
      let arrowtop = buttonRect.bottom - (parentRect?.top || 0) // Default arrow position
      const arrowleft = buttonRect.left - (parentRect?.left || 0) + buttonRect.width / 2 // Default arrow center
 
      const spaceBelow = window.innerHeight - buttonRect.bottom // Space below button
      const spaceAbove = buttonRect.top - 156 // Space above button
      const spaceRight = window.innerWidth - buttonRect.right // Space to the right
      const spaceLeft = buttonRect.left // Space to the left
 
      // Determine if the popup should be above or below
      if (spaceBelow >= spaceAbove) {
        maxHeight = spaceBelow // Enough space below
      } else {
        top = buttonRect.top - popupRect.height - (parentRect?.top || 0) // Position above the button
        arrowtop = buttonRect.top - (parentRect?.top || 0)
        maxHeight = spaceAbove // Limit height to available space above
      }
      // Adjust for insufficient right space
      if (left + popupRect.width + (parentRect?.left || 0) > window.innerWidth) {
        if (spaceRight < popupRect.width && spaceLeft >= popupRect.width) {
          left = buttonRect.right - popupRect.width - (parentRect?.left || 0)
        } else {
          left = window.innerWidth - popupRect.width - (parentRect?.left || 0)
        }
      }
 
      setPopupPosition({ top, left, maxHeight, arrowtop, arrowleft })
 
      // Send the top position back to the parent component, if the callback exists
      if (onPositionChange) {
        onPositionChange(top)
      }
    }
  }, [onPositionChange])

  useEffect(() => {
    // Initial position calculation
    updatePopupPosition()

    // Recalculate position on window resize
    window.addEventListener('resize', updatePopupPosition)

    // Cleanup on unmount
    return () => {
      window.removeEventListener('resize', updatePopupPosition)
    }
  }, [ updatePopupPosition])

  useEffect(() =>{
    setPopupPosition({ top: 0, left: 0, maxHeight: 0, arrowtop: 0,arrowleft:0 })
    setTimeout(() =>{
      updatePopupPosition()
    },200)
  },[window.innerWidth])

  // Manage fade-in and fade-out transitions
  useEffect(() => {
    if (multiplePopup === popupId) {
      setIsVisible(true) // Trigger fade-in when popup is active
      updatePopupPosition() // Recalculate position when popup becomes active
    } else if (isVisible) {
      setIsVisible(false) // Trigger fade-out and wait for the animation
    }
  }, [multiplePopup, popupId, isVisible, updatePopupPosition])

  if (!isVisible && multiplePopup !== popupId) return null

  return (
    <>
    {popuparrow && 
    <div 
    style={{
      top: popupPosition.top >= 0 ? popupPosition.top : popupPosition.arrowtop - 8 ,
      left: popupPosition.arrowleft
    }}
    className={`arrow ${popupPosition.top >= 0 ? 'arrow-bottom' : 'arrow-top'}`}></div>
  }
    <div
      ref={popupRef}
      className={`${className} ${multiplePopup === popupId ? 'fade-in' : 'fade-out'}`}
      style={{
        top: popuparrow ? (popupPosition.top >= 0 ? popupPosition.top + 8 : popupPosition.top - 8) : popupPosition.top + 2 ,
        left: popupPosition.left,
        maxHeight: popuparrow ? popupPosition.maxHeight - 8 : popupPosition.maxHeight, // Dynamically set max-height based on available space
      }}
      id={popupId}
    >
      {popupTitle || popupHeaderClose && <div className={`d-flex ${popupHeaderClass}`}>
        <h1 tabIndex={0} aria-label={popupTitle}>{popupTitle}</h1>
      </div>}
      {popupContent && <div className={popupContentClass}>
        {popupContent}
      </div>}
      {popupActions && <div className={popupFooterClass} >
        {popupActions}
        {popupFooterClose && <button className={popupFooterCloseIcon} onClick={() => setMultiplePopup(null)} title={popupFooterClose}><span className={closebtnclass}></span>{popupFooterClose}</button>}
      </div>}
      {popupHeaderClose && <button className={popupHeaderClose} onClick={() => setMultiplePopup(null)}><span className={closebtnclass}></span>{popupHeaderClose}</button>}
    </div>
    </>
  )
}

export default React.memo(Popups)